import { useEffect, useRef, HTMLAttributes } from 'react';
// import Templater from '../../templater/Templater';

type TDontAsk = HTMLAttributes<HTMLDivElement> & {
  dontDoItHTML: string;
};

const DontAsk = ({ dontDoItHTML, ...attrs }: TDontAsk) => {
  const divRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!dontDoItHTML || !divRef.current) throw new Error('bad parsed HTML');
    const iHTML = document.createRange().createContextualFragment(dontDoItHTML);
    // console.log(dontDoItHTML);
    // const s = Templater.parseString(dontDoItHTML);
    // console.log(s);

    divRef.current.innerHTML = '';
    divRef.current.appendChild(iHTML);
  }, [dontDoItHTML, divRef]);

  return <div {...attrs} ref={divRef} />;
  // return <s />;
};

export default DontAsk;
